import { GridOptions } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import {  VALUE_ENTER, WIZ_EVENT_TYPE, WizDateUtils, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizAgGridUtils,
  WizEvent, WizEventManager
} from '@wizeoo/akm-component-lib';
import { BaselineEngine, FeiKeyDef, FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';
import { ColDef } from 'ag-grid-community';
import { WidgetLine } from '@wizeoo/akm-compute-lib';

import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { Model } from '../../../../model/model';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { WIDGET_GLOBAL_KIND } from '../../../../model/enums';
import { IForm } from '../../../../manager/widgets/i-form';
import { ViewData } from '../../../../model/view.data';
import { FeiVO } from '../../../../vo/workingdata/fei.vo';


// popUp de sélection dans les éléments de clé des formulaires
@Component({
  selector: 'form-drop-extended-freedata-pop',
  templateUrl: './form-drop-extended-freedata.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDropExtendedFreedataPop extends WizBasePopUp {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  gridOptions: GridOptions = {
    // suppressRowClickSelection: true,
    onRowDoubleClicked: (params) => this.onRowDouble(params)
  };


  public ffo: FormFieldObj; // l'objet source
  public currentValue: string; // la valeur en cours
  public declare callback: Function; // fonction de retour vers le pivotComponent pour application
  public freedata: FreeDataVO;

  public measureFilterMode: boolean = false; // pas une Key ni un FD, une mesure de type filter

  private doSaveFlag: boolean = true;

  @ViewChild('agGrid') agGrid: WizAgGrid<FreedataValueVO>;
  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre


  public get model(): Model {
    return this.ffo.widget?.model || this.ffo.model; // mode vue FDV
  }

  public dataDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>([]) // DS de la liste
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();



  public keyGridColumns: ColDef[] = [];

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    this.ffo = this.datas[0];
    this.currentValue = this.datas[1];
    this.callback = this.datas[2];

    this.feed();
    this.addListeners();
  }


  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: FreedataValueVO): boolean {
    if(item.deprecated) { // masquer les deprecated
      return false;
    }

    if(!!item.endDate && WizDateUtils.numberToDate(item.endDate) < WizDateUtils.TODAY) { // masquer les deprecated
      return false;
    }

    // contrôle par filtre utilisateur
    if(!this.model.widgetEngine.doUserFilterOnFDV(item)) {
      return false;
    }

    // contrôle par filtre global
    if(!this.model.widgetEngine.doGlobalFilterOnFDV(item)) {
      return false;
    }

    return this.popFilter.checkVisible(item.argsObjVO);
  }


  public get keyPartMap(): Map<string, string> {
    let result:  Map<string, string> = new Map();

    if(this.ffo.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) {
      result = (this.ffo.widget as IForm).keyPartMap;
    } else { // construction de la map de valeur sur la base des args

      const wid: IForm = this.ffo.widget as IForm;
      const fd: FreeDataVO = wid?.freedata;
      
      const fdv: FreedataValueVO = wid?.clone as FreedataValueVO; // c'est un FDV
      
      [...fd.getArgsVOMap()?.values() || []].forEach((arg: FreedataArgsVO) => {
        let fdvVal: any = fdv.argsObjVO[arg.code];
        let fdvFinal: string = null;
        if(!!fdvVal) {
          if(arg.dataType === FIELD_KIND.NUMBER) {
            fdvFinal = fdvVal.toString();
          } else if (arg.dataType === FIELD_KIND.OBJECT) {
             fdvFinal = fdvVal.split(WizConstants.CONTEXT_SEPARATOR).pop();
          } else {
            fdvFinal = fdvVal;
          }
          
        }
        result.set(arg.datas, fdvFinal);

      });
      
      // console.log('FDV drop', this.ffo.clone, result);
    }

    return result;
  }


  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {
    let fdvs: FreedataValueVO[];

    if(this.ffo.freedataMode) {

      // gestion du code parent
      if(this.ffo.arg.code === WizConstants.FIELD_PARENT_CODE) {
        let fdCode: string = this.ffo.fkd.code;
        this.freedata = this.model.freedataEngine.getFreeData(fdCode);
        fdvs = this.model.freedataEngine.getFreedataValuesByLevel([fdCode, (this.ffo.clone.level -1).toString()].join(WizConstants.CONTEXT_SEPARATOR));  
      } else {
        let fdCode: string = this.ffo.arg.datas.split(WizConstants.CONTEXT_SEPARATOR)[0];
        this.freedata = this.model.freedataEngine.getFreeData(fdCode);
        fdvs = this.model.freedataEngine.getFreedataValuesByLevel(this.ffo.arg.datas);  
      }

    } else {

      // gestion des mesures de type Filter
      let fkd: FeiKeyDef = this.ffo.fkd;
      if(fkd.isMeasure && fkd.measure.dataKind === FIELD_KIND.FILTER) {
        this.measureFilterMode = true;
        try {
          let FDCode: string = (fkd.measure.settings as any).keys[0].FD;        
          fdvs = this.model.freedataEngine.getFreedataValuesByLevel(FDCode);
          this.freedata = this.model.freedataEngine.getFreeData(FDCode.split(WizConstants.CONTEXT_SEPARATOR)[0]); 
        } catch (e:any) {
          fdvs = [];
          this.freedata = null;
          //console.log("force DDExt on filter oups", e);     
        }
      } else if (fkd.isMeasure && fkd.measure.dataKind === FIELD_KIND.CROSS_FILTER) {
        console.log("TODO TODO force DDExt on cross filter oups");     
      }
      else {
        fdvs = this.model.freedataEngine.getFreedataValuesByLevel(this.ffo.fkd.fullCode);
        this.freedata = this.model.freedataEngine.getFreeData(this.ffo.fkd.code);
      }

    }

    const wid: IForm = this.ffo.widget as IForm;
    
    const fei: FeiVO = wid?.fakeFei; // TODO TODO fakeFEI ??
    const widgetLine: WidgetLine = wid?.clone; // TODO TODO c'est possiblement un FDV
    
    // jouer les restricts sur les FDVs
    let allowedFdvs: FreedataValueVO[] = [];
    
    if(!wid) { // pas en mode formulaire ?? vue freedata ?
      // TODO jouer les restrictions
      // fdvs = this.restrictFromAncestorOnFDV(fdvs);
      allowedFdvs = [...fdvs];
      
    } else {
      if(this.ffo.freedataMode) { // formulaire FD
        fdvs = this.restrictFromAncestorOnFDV(fdvs);
      } else {
        if(!this.measureFilterMode) {
          fdvs = this.restrictFromAncestor(fdvs);
        } else {// contrôle de l'unique
          let fkd: FeiKeyDef = this.ffo.fkd;
          let fei: FeiVO = this.ffo.widget.fei;
          let unique: boolean = !!(fkd.measure.settings as any).keys[0].unique;
          if(unique) {
            let existSet: Set<string> = new Set();
            [...fei.getAllLines()].forEach(wl => {
              let wlVal: string = BaselineEngine.getValue(fei, wl, wl?.cells?.get(fkd.fullCode)); 
              existSet.add(wlVal);
            });

            // console.log("unique existSet", existSet);

            let realsource: FreedataValueVO[]= [];
            fdvs.forEach(fdv => {
              if(existSet.has(fdv.shortCode)) {
                // console.log('out', fdv.shortCode);
              } else {
                realsource.push(fdv);
              }
            });
            fdvs = realsource;
          }
        }
        
      }
      
      // gestion des restrictions
      fdvs.forEach((fdavo: FreedataValueVO) => {
        if(!this.model.widgetEngine.computeListRestrict(this.ffo.widget, fei, widgetLine, fdavo, true, this.keyPartMap)) {
          allowedFdvs.push(fdavo);
        } else {
          // console.log('feed fdropext hidden', fei, widgetLine, fdavo);
        }
      });
    }





    // les colonnes choisies pour l'affichage
    let cols: string[] = [];
    
    // TODO TODO settings si measure.filter
    // console.log('ffe', this.ffo.wcio.fdvSearch);
    if(this.measureFilterMode) {
      (this.ffo.fkd.measure.settings as any).keys[0].fields.forEach(f => {
        cols.push(f.code);
      });
    }
    else if (!!this.ffo.wcio.fdvSearch) {
      const more: string[] = this.ffo.wcio.fdvSearch.split(ViewData.KEY_SEPARATOR);
      more.forEach(s => { // pas de doublons
        if (cols.indexOf(s)<0) {
          cols.push(s);
        }
      })
    }
    if(cols.length <=0) {
      cols = [WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL]; // si rien de défini, code, label
    }


    this.keyGridColumns = [];
    
    const sortKey: any[] = []; // trier par ordre de colonnes

    cols.forEach( col => {

      let src: string = null; // le code du FD
      if(this.measureFilterMode) {
        let FDCode: string = (this.ffo.fkd.measure.settings as any).keys[0].FD; 
        src = FDCode.split(WizConstants.CONTEXT_SEPARATOR)[0]  ;  
      } else {
        src = this.ffo.fkd?.code;
      }
      
      if(!src) {
        try {
          src = this.ffo.arg?.datas.split(WizConstants.CONTEXT_SEPARATOR)[0];
        } catch(e: any) {}
      }

      const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(src, col);
      let realField: string = 'argsObjVO' +'.'+ col;
      // TODO rendu des colonnes pour les sous-FD (genre Labs)
      let size: number = !!arg.defaultSize ? arg.defaultSize : 100;
      sortKey.push({property: realField, way: 'asc', numeric: this.model.dataEngine.datakindIsNumeric(arg.dataType)});
      let coldef: any = { headerName: arg.trsLabel, width: size, sortable: true, resizable: true, field: realField };
      if (arg.dataType === FIELD_KIND.BINARY) {
        coldef.cellClass = 'grid-cell-centered';
        coldef.cellRenderer = this.model.gridAccessors.attachmentCellRender;
        coldef.valueFormatter = this.voidFormatter;
        coldef.tooltipField = null;
      } else if (arg.dataType === FIELD_KIND.BINARY_MULTI) {
        coldef.cellClass = 'grid-cell-centered';
        coldef.cellRenderer = this.model.gridAccessors.attachmentMultiCellRender;
        coldef.valueFormatter = this.voidFormatter;
        coldef.tooltipField = null;
      } else if (arg.dataType === FIELD_KIND.BOOLEAN) {
        coldef.cellClass = 'cbox-cell';
        coldef.cellClass += ' no-edit';
        coldef.valueFormatter = this.voidFormatter;
        coldef.cellRenderer = WizAgGridUtils.CELL_CHECKBOX_RENDERER;
      } else {
        coldef.valueFormatter = this.goodFormatter;
      }
      this.keyGridColumns.push(coldef);
    });
    this.popFilter.configure(cols, null, null).build();

    this.dataDS.setSource(allowedFdvs);
    this.dataDS.setSortFields(sortKey);
    this.dataDS.refresh();
    
    
    let fdv: FreedataValueVO = null;
    let idx: number = 0; // indice de ligne sélectionnée
    
    if (!!this.currentValue) {
      let splitted: string[] = this.currentValue.split(ViewData.CONTEXT_SEPARATOR);
      if(splitted.length>1) {
        fdv = this.dataDS.getItemByKey(splitted[1]);
      } else if (splitted.length === 1) {
        fdv = this.dataDS.getItemByKey(splitted[0]);
      }
      // console.log('this.currentValue', this.currentValue, fdv);
      
    }
    this.dataDS.select([fdv]);
    if(!!fdv) {
      idx = this.dataDS.getWorkedSource().indexOf(fdv);
      this.agGrid.api.ensureIndexVisible(idx,'top');
    }

    setTimeout(() => {
      this.agGrid.api.setFocusedCell(idx,this.keyGridColumns[0].field!);
    }, 0);

  }

  private voidFormatter(val: any): any {
    return val.value;
  }

  private goodFormatter(val: any): any {
    let result: string = val.value;
    // prise du arg. Si c'est un objet, on chope la label sur le subFDV
    try {
      let field: string = val.colDef.field.split('.')[1];
      let fdv: FreedataValueVO = val.data;
      let arg: FreedataArgsVO = Model.getInstance().freedataEngine.getArgFromFD(fdv.freeDataCode, field);
      if(arg.dataType === FIELD_KIND.OBJECT) {
        let parts: string[] = val.value.split(WizConstants.CONTEXT_SEPARATOR);
        let realFDV: FreedataValueVO = Model.getInstance().freedataEngine.getFreedataValue(parts[0], parts[1]);
        result = Model.getInstance().freedataEngine.getFDValue(realFDV, ViewData.FIELD_LABEL);
      }
    } catch(e: any) {
       // console.log('oups', val.value);
    }
    
    // console.log('goodFormatter', val.value, result);
    
    return result;
  }


  /**
   * Refresh du filtre
   * @param event : Evenement de changement dans la zone de filtre
   */
  private refreshFilter(event: WizEvent = null): void {
    this.dataDS.refresh();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // Filtres
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.refreshFilter);
  }

  /** double-clic sur une ligne, sélection single auto + dispatch */
  private onRowDouble(params: any): void {
    this.dataDS.select([params.data]);
    this.save();
  }


  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  public onHide() {
    if (this.doSaveFlag) {
      const val: string = this.dataDS.selectedItem ? this.dataDS.selectedItem.code : null;
      if(!!this.callback) {
        this.callback(val);
      }
      
    }
  }

  // les clés actives sur le même FD / CHRONO que mois
  private ancestorKey: FreedataValueVO = null;
  // j'ai un ancêtre dans le formulaire
  private ancestorKeyExist: boolean = false;


  // /** construction du set de valeurs de mes ancêtres dans le widget. Pour application rapide de la filterFunc */
  private restrictFromAncestor(fdvs: FreedataValueVO[]): FreedataValueVO[] {
    if (!this.ffo?.fkd) {
      return fdvs;
    }
    
    if(!this.ancestorKey) { // alimentation du set d'ancêtres
      const strictCode: string = this.ffo.fkd.code; // clé simple (sans #lvl)
      const refLevel = this.ffo.fkd.level; // référence du level en cours
      if(refLevel > 1) { // pas besoin au premier niveau
        // prise des clés sur le widget
        let keyPartMap: Map<string, string> = this.keyPartMap;
    
        // prise du level de l'ancêtre, au plus proche, au mieux
        let referenceLevel: number = -1;

        Array.from(keyPartMap.keys()).forEach((inMapKey) => {
          if(!!inMapKey) {
            const inMapStrict = inMapKey.split(ViewData.CONTEXT_SEPARATOR)[0];
            if (inMapStrict === strictCode) {
              const inMapLevel: number = Number(inMapKey.split(ViewData.CONTEXT_SEPARATOR)[1]);
              if (inMapLevel < refLevel && // un ancêtre
                  !!keyPartMap.get(inMapKey) && // avec une valeur
                  inMapLevel > referenceLevel) { // et plus proche que ce que j'ai déjà identifié
                
                let key: string = keyPartMap.get(inMapKey);
                referenceLevel = inMapLevel;
                this.ancestorKey = this.freedata.getFreeDataValue(key);
              }
            }
          }
        });
      }
    }

    let allowed: FreedataValueVO[] = [];
    if(!this.ancestorKey) { // pas d'ancêtre, tout est OK
      allowed = fdvs;
    } else { // l'ancêtre doit être dans ma pile d'héritage
      
      let parentFDV: FreedataValueVO = null;
      fdvs.forEach((fdv: FreedataValueVO) => {
        parentFDV = fdv.getParentVO();
        while (parentFDV.level > this.ancestorKey.level) {
          parentFDV = parentFDV.getParentVO();
        }

        if(parentFDV.code === this.ancestorKey.code) { // c'est mon ancêtre
          allowed.push(fdv);
        }
      });

    }
    return allowed;
  }

  public askForUnselect(): void {
    this.dataDS.clearSelection();
    // console.log('askForUnselect');
  }

  /** 
   * construction du set de valeurs de mes ancêtres dans le widget.
   * gestion de la cascade pour les FD-Forms */
  private restrictFromAncestorOnFDV(fdvs: FreedataValueVO[]): FreedataValueVO[] {
  
    if(!this.ancestorKey) { // alimentation du set d'ancêtres
      // prise du arg
      let arg: FreedataArgsVO = this.ffo.arg;
      let fdFullPart: string;
      let strictCode: string;
      let refLevel: number;
      if(arg?.dataType === FIELD_KIND.OBJECT) {
        fdFullPart = arg.datas;
        strictCode = fdFullPart.split(WizConstants.CONTEXT_SEPARATOR)[0]; 
        refLevel = Number(fdFullPart.split(WizConstants.CONTEXT_SEPARATOR)[1]); 
      }
      
      if(refLevel > 1) { // pas besoin au premier niveau
        // prise des clés sur le widget
        let keyPartMap: Map<string, string> = this.keyPartMap;
    
        //console.log('strictCode', strictCode, refLevel, keyPartMap);

        // prise du level de l'ancêtre, au plus proche, au mieux
        let referenceLevel: number = -1;

        Array.from(keyPartMap.keys()).forEach((inMapKey) => {
          if(!!inMapKey) {
            const inMapStrict = inMapKey.split(ViewData.CONTEXT_SEPARATOR)[0];
            if (inMapStrict === strictCode) {
              const inMapLevel: number = Number(inMapKey.split(ViewData.CONTEXT_SEPARATOR)[1]);
              if (inMapLevel < refLevel && inMapLevel > referenceLevel) { // ancêtre plus proche que ce que j'ai déjà identifié
                
                let key: string = keyPartMap.get(inMapKey);
                referenceLevel = inMapLevel;
                
                this.ancestorKeyExist = true; // j'ai un ancêtre, il doit avoir une valeur
                if(!!keyPartMap.get(inMapKey)) {
                  this.ancestorKey = this.freedata.getFreeDataValue(key);
                } else {
                  this.ancestorKey = null;
                }
              }

            }
          }
        });
      }
    }

    let allowed: FreedataValueVO[] = [];
    if(!this.ancestorKeyExist) { // pas d'ancêtre, tout est OK
      allowed = fdvs;
    } else { // l'ancêtre doit être dans ma pile d'héritage
      if(this.ancestorKeyExist && !this.ancestorKey) {
        // ancêtre pas alimenté, rien
      } else {
        let parentFDV: FreedataValueVO = null;
        fdvs.forEach((fdv: FreedataValueVO) => {
          parentFDV = fdv.getParentVO();
          while (parentFDV.level > this.ancestorKey.level) {
            parentFDV = parentFDV.getParentVO();
          }

          if(parentFDV.code === this.ancestorKey.code) { // c'est mon ancêtre
            allowed.push(fdv);
          }
        });
      }
    }
    return allowed;
  }


}
